<div class="modal fade" id="settingsModal" tabindex="-1" aria-labelledby="settingsModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
        <div class="modal-content border-0">
            <div class="modal-body p-0">
                <div class="container-fluid p-0 text-light h-100 settings-overlay">
                    <div class="row g-0 h-100 flex-column flex-lg-row flex-nowrap flex-lg-wrap">
                        <!-- Left Sidebar -->
                        <aside class="col-12 col-lg-3 settings-sidebar d-flex flex-column">
                        <!-- Profile Snippet -->
                        <div class="profile-header d-flex align-items-center mb-3">
                            <img [src]="currentUserAvatar()" class="rounded-circle me-2 profile-avatar" width="32"
                                height="32" alt="Avatar">
                            <div class="profile-info text-truncate">
                                <span class="profile-name fw-bold d-block text-truncate">{{ currentUser().name }}</span>
                                <span class="profile-edit small text-muted cursor-pointer"
                                    (click)="showComingSoon('Edit Profile')"><i
                                        class="bi bi-pencil-fill me-1 text-secondary"></i>Edit Profiles</span>
                            </div>
                        </div>

                        <!-- Search Bar -->
                        <div class="search-container mb-3 position-relative">
                            <input type="text" class="form-control form-control-sm search-input" placeholder="Search">
                            <i class="bi bi-search search-icon position-absolute"></i>
                        </div>

                        <!-- Navigation Menu -->
                        <nav class="settings-nav flex-grow-1 overflow-auto pe-2">
                            <div class="nav-section-title">User Settings</div>
                            <button class="nav-item-btn" [class.active]="activeTab() === 'account'"
                                (click)="setActiveTab('account')">
                                <i class="bi bi-person-fill me-2"></i> Account
                            </button>


                            <div class="nav-section-title mt-3">App Settings</div>
                            <button class="nav-item-btn" [class.active]="activeTab() === 'appearance'"
                                (click)="setActiveTab('appearance')">
                                <i class="bi bi-palette-fill me-2"></i> Appearance
                            </button>
                            <button class="nav-item-btn" [class.active]="activeTab() === 'audio'"
                                (click)="setActiveTab('audio')">
                                <i class="bi bi-volume-up-fill me-2"></i> Audio & Voice
                            </button>
                            <button class="nav-item-btn" [class.active]="activeTab() === 'privacy'"
                                (click)="setActiveTab('privacy')">
                                <i class="bi bi-shield-lock-fill me-2"></i> Data & Privacy
                            </button>
                            <button class="nav-item-btn" (click)="showComingSoon('Notifications')">
                                <i class="bi bi-bell-fill me-2"></i> Notifications
                            </button>

                            <div class="nav-section-title mt-3">Billing</div>
                            <button class="nav-item-btn" (click)="showComingSoon('Subscriptions')">
                                <i class="bi bi-card-checklist me-2"></i> Subscriptions
                            </button>
                            <button class="nav-item-btn" (click)="showComingSoon('Gift Inventory')">
                                <i class="bi bi-gift-fill me-2"></i> Gift Inventory
                            </button>
                            <button class="nav-item-btn" (click)="showComingSoon('Billing')">
                                <i class="bi bi-credit-card-fill me-2"></i> Billing
                            </button>
                        </nav>
                    </aside>

                    <!-- Main Content Area -->
                    <main class="col-12 col-lg-9 settings-content p-5 d-flex flex-column position-relative">
                        <!-- Close Button -->
                        <button
                            class="btn-close-settings position-absolute d-flex align-items-center justify-content-center"
                            data-bs-dismiss="modal" aria-label="Close" title="Close Settings">
                            <i class="bi bi-x-lg fs-5"></i>
                            <span class="close-label">ESC</span>
                        </button>

                        <!-- Tab contents scroll wrapper -->
                        <div class="content-scroll-wrapper flex-grow-1 overflow-auto">
                            <!-- Account Tab -->
                            @if (activeTab() === 'account') {
                            <div class="settings-tab-pane">
                                <h3 class="mb-4 fw-bold">Account</h3>

                                <!-- Account Info Section -->
                                <div class="settings-section mb-5">
                                    <h5 class="section-title text-uppercase mb-3">Account Info</h5>
                                    <div class="settings-panel p-4 rounded-4 mb-3">
                                        <!-- Username Row -->
                                        <div class="d-flex align-items-between justify-content-between py-3">
                                            <div class="d-flex flex-column">
                                                <span class="row-label text-muted small text-uppercase">Username</span>
                                                <span class="row-value fw-semibold fs-5">{{ currentUser().name }}</span>
                                            </div>
                                        </div>
                                        <!-- Email Row -->
                                        @if (!isEditingEmail()) {
                                        <div class="d-flex align-items-center justify-content-between py-3">
                                            <div class="d-flex flex-column">
                                                <span class="row-label text-muted small text-uppercase">Email</span>
                                                <div class="d-flex align-items-center gap-2">
                                                    <span class="row-value fw-semibold fs-5">{{ emailDisplay() }}</span>
                                                    <span class="reveal-link small text-neon-purple cursor-pointer"
                                                        (click)="toggleRevealEmail()">
                                                        {{ revealEmail() ? 'Hide' : 'Reveal' }}
                                                    </span>
                                                </div>
                                            </div>
                                            <button class="btn btn-settings-dark px-3 py-1-5"
                                                (click)="isEditingEmail.set(true)">Edit</button>
                                        </div>
                                        } @else {
                                        <div class="py-3">
                                            <app-edit-email (cancel)="isEditingEmail.set(false)"></app-edit-email>
                                        </div>
                                        }
                                        <!-- Phone Number Row -->
                                        @if (!isEditingPhone()) {
                                        <div class="d-flex align-items-center justify-content-between py-3">
                                            <div class="d-flex flex-column">
                                                <span class="row-label text-muted small text-uppercase">Phone
                                                    Number</span>
                                                <span class="row-value fw-semibold fs-5 text-muted">You haven't added a
                                                    phone number yet.</span>
                                            </div>
                                            <button class="btn btn-settings-dark px-3 py-1-5"
                                                (click)="isEditingPhone.set(true)">Add</button>
                                        </div>
                                        } @else {
                                        <div class="py-3">
                                            <app-add-phone (cancel)="isEditingPhone.set(false)"></app-add-phone>
                                        </div>
                                        }
                                    </div>
                                </div>

                                <!-- Password & Security Section -->
                                <div class="settings-section mb-5">
                                    <h5 class="section-title text-uppercase mb-3">Password & Security</h5>
                                    <div class="settings-panel p-4 rounded-4 mb-3">
                                        <!-- Password Row -->
                                        @if (!isEditingPassword()) {
                                        <div class="d-flex align-items-center justify-content-between py-3">
                                            <div class="d-flex flex-column">
                                                <span class="row-label text-muted small text-uppercase">Password</span>
                                                <span class="row-value fw-semibold fs-5">●●●●●●●●●●●●●●●</span>
                                            </div>
                                            <button class="btn btn-settings-dark px-3 py-1-5"
                                                (click)="isEditingPassword.set(true)">Edit</button>
                                        </div>
                                        } @else {
                                        <div class="py-3">
                                            <app-change-password
                                                (cancel)="isEditingPassword.set(false)"></app-change-password>
                                        </div>
                                        }
                                        <!-- MFA Row -->
                                        <div class="d-flex align-items-center justify-content-between py-3 cursor-pointer"
                                            (click)="showComingSoon('Multi-Factor Authentication')">
                                            <div class="d-flex flex-column flex-grow-1">
                                                <span class="row-value fw-semibold fs-5">Multi-Factor
                                                    Authentication</span>
                                            </div>
                                            <span class="action-arrow text-muted fs-5">Set up <i
                                                    class="bi bi-chevron-right ms-1"></i></span>
                                        </div>
                                        <!-- Devices Row -->
                                        <div class="d-flex align-items-center justify-content-between py-3 cursor-pointer"
                                            (click)="showComingSoon('Logged in Devices')">
                                            <div class="d-flex flex-column flex-grow-1">
                                                <span class="row-value fw-semibold fs-5">Logged in Devices</span>
                                            </div>
                                            <span class="action-arrow text-muted fs-5">1 devices <i
                                                    class="bi bi-chevron-right ms-1"></i></span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Account Standing Section -->
                                <div class="settings-section mb-5">
                                    <h5 class="section-title text-uppercase mb-3">Account Standing</h5>
                                    <div class="standing-banner p-4 rounded-4 d-flex align-items-center justify-content-between cursor-pointer"
                                        (click)="showComingSoon('Account Standing Details')">
                                        <div class="d-flex align-items-center gap-3">
                                            <div class="standing-icon-container d-flex align-items-center justify-content-center rounded-circle bg-success bg-opacity-20 text-success"
                                                style="width: 40px; height: 40px; flex-shrink: 0;">
                                                <i class="bi bi-check-lg fs-4"></i>
                                            </div>
                                            <div class="d-flex flex-column">
                                                <span class="standing-title fw-bold fs-5 text-white">Your account is all
                                                    good</span>
                                                <span class="standing-desc text-muted small mt-1">Thanks for upholding
                                                    Rival Forge's Terms of Service and Community Guidelines. If you
                                                    break the rules, it will show up here.</span>
                                            </div>
                                        </div>
                                        <i class="bi bi-chevron-right text-muted fs-4"></i>
                                    </div>
                                </div>
                            </div>
                            }

                            <!-- Appearance Tab -->
                            @if (activeTab() === 'appearance') {
                            <div class="settings-tab-pane">
                                <h3 class="mb-4 fw-bold">Appearance</h3>

                                <div class="row g-4">
                                    <!-- Chat Customization -->
                                    <div class="col-12 col-md-6">
                                        <div class="settings-section">
                                            <h5
                                                class="section-title text-uppercase mb-3 border-bottom border-secondary border-opacity-20 pb-2">
                                                Chat Preferences</h5>
                                            <div class="settings-panel p-4 rounded-4 mb-4">
                                                <div class="mb-4">
                                                    <label for="userNameColor"
                                                        class="form-label d-flex justify-content-between">
                                                        <span>Username Color</span>
                                                        <span class="text-secondary small">{{ tempUserNameColor() }}</span>
                                                    </label>
                                                    <div class="d-flex gap-2 align-items-center">
                                                        <input type="color"
                                                            class="form-control form-control-color border-0 rounded-circle"
                                                            id="userNameColor" [ngModel]="tempUserNameColor()"
                                                            (ngModelChange)="tempUserNameColor.set($event)"
                                                            style="width: 3rem; height: 3rem; padding: 0.2rem; cursor: pointer; background: none;">
                                                        <input type="text" class="form-control flex-grow-1"
                                                            [ngModel]="tempUserNameColor()"
                                                            (ngModelChange)="tempUserNameColor.set($event)"
                                                            placeholder="#9f50ff">
                                                    </div>
                                                </div>
                                                <div class="mb-4">
                                                    <label for="fontColor"
                                                        class="form-label d-flex justify-content-between">
                                                        <span>Chat Font Color</span>
                                                        <span class="text-secondary small">{{ tempFontColor() }}</span>
                                                    </label>
                                                    <div class="d-flex gap-2 align-items-center">
                                                        <input type="color"
                                                            class="form-control form-control-color border-0 rounded-circle"
                                                            id="fontColor" [ngModel]="tempFontColor()"
                                                            (ngModelChange)="tempFontColor.set($event)"
                                                            style="width: 3rem; height: 3rem; padding: 0.2rem; cursor: pointer; background: none;">
                                                        <input type="text" class="form-control flex-grow-1"
                                                            [ngModel]="tempFontColor()"
                                                            (ngModelChange)="tempFontColor.set($event)"
                                                            placeholder="#ffffff">
                                                    </div>
                                                </div>
                                                <div class="mb-3">
                                                    <label for="fontStyle" class="form-label">Font Style</label>
                                                    <select id="fontStyle" class="form-select" [ngModel]="tempFontStyle()"
                                                        (ngModelChange)="tempFontStyle.set($event)">
                                                        <option value="normal">Normal</option>
                                                        <option value="italic">Italic</option>
                                                        <option value="bold">Bold</option>
                                                        <option value="monospace">Monospace</option>
                                                    </select>
                                                </div>
                                                <div class="mt-3 pt-2 border-top border-secondary border-opacity-10">
                                                    <button type="button" class="btn btn-settings-danger px-4 py-2 fw-bold w-100" (click)="applyAppearanceSettings()">
                                                        Apply
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Graphics Preferences -->
                                    <div class="col-12 col-md-6">
                                        <div class="settings-section">
                                            <h5
                                                class="section-title text-uppercase mb-3 border-bottom border-secondary border-opacity-20 pb-2">
                                                Graphics Settings</h5>
                                            <div class="settings-panel p-4 rounded-4 mb-4">
                                                <div class="mb-4">
                                                    <label for="resolution" class="form-label">Resolution</label>
                                                    <select id="resolution" class="form-select">
                                                        <option selected>1920 x 1080</option>
                                                        <option>1600 x 900</option>
                                                        <option>1280 x 720</option>
                                                    </select>
                                                </div>
                                                <div class="mb-4">
                                                    <label for="graphicsQuality" class="form-label">Graphics
                                                        Quality</label>
                                                    <select id="graphicsQuality" class="form-select">
                                                        <option>Low</option>
                                                        <option>Medium</option>
                                                        <option selected>High</option>
                                                        <option>Ultra</option>
                                                    </select>
                                                </div>
                                                <div class="d-flex flex-column gap-3 mt-4">
                                                    <div class="form-check form-switch fs-5">
                                                        <input class="form-check-input" type="checkbox" role="switch"
                                                            id="enableShadows" [ngModel]="enableShadows()"
                                                            (ngModelChange)="enableShadows.set($event)">
                                                        <label class="form-check-label" for="enableShadows">Enable
                                                            Shadows</label>
                                                    </div>
                                                    <div class="form-check form-switch fs-5">
                                                        <input class="form-check-input" type="checkbox" role="switch"
                                                            id="enableAnimations" [ngModel]="enableAnimations()"
                                                            (ngModelChange)="enableAnimations.set($event)">
                                                        <label class="form-check-label" for="enableAnimations">Enable
                                                            Animations</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            }

                            <!-- Audio & Voice Tab -->
                            @if (activeTab() === 'audio') {
                            <div class="settings-tab-pane">
                                <h3 class="mb-4 fw-bold">Audio & Voice</h3>

                                <div class="row g-4">
                                    <!-- Volume Controls -->
                                    <div class="col-12 col-md-6">
                                        <div class="settings-section">
                                            <h5
                                                class="section-title text-uppercase mb-3 border-bottom border-secondary border-opacity-20 pb-2">
                                                Volume Mixers</h5>
                                            <div class="settings-panel p-4 rounded-4 mb-4">
                                                <div class="mb-4">
                                                    <label for="masterVolume"
                                                        class="form-label d-flex justify-content-between">
                                                        <span>Master Volume</span>
                                                        <span>{{ masterVolume() }}%</span>
                                                    </label>
                                                    <input type="range" class="form-range" id="masterVolume" min="0"
                                                        max="100" [ngModel]="masterVolume()"
                                                        (ngModelChange)="masterVolume.set($event)">
                                                </div>
                                                <div class="mb-4">
                                                    <label for="musicVolume"
                                                        class="form-label d-flex justify-content-between">
                                                        <span>Music Volume</span>
                                                        <span>{{ musicVolume() }}%</span>
                                                    </label>
                                                    <input type="range" class="form-range" id="musicVolume" min="0"
                                                        max="100" [ngModel]="musicVolume()"
                                                        (ngModelChange)="musicVolume.set($event)">
                                                </div>
                                                <div class="mb-2">
                                                    <label for="sfxVolume"
                                                        class="form-label d-flex justify-content-between">
                                                        <span>SFX Volume</span>
                                                        <span>{{ sfxVolume() }}%</span>
                                                    </label>
                                                    <input type="range" class="form-range" id="sfxVolume" min="0"
                                                        max="100" [ngModel]="sfxVolume()"
                                                        (ngModelChange)="sfxVolume.set($event)">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Voice Devices -->
                                    <div class="col-12 col-md-6">
                                        <div class="settings-section">
                                            <h5
                                                class="section-title text-uppercase mb-3 border-bottom border-secondary border-opacity-20 pb-2">
                                                Voice Hardware</h5>
                                            <div class="settings-panel p-4 rounded-4 mb-4">
                                                @if (micPermissionError()) {
                                                <div
                                                    class="alert alert-warning small p-3 d-flex flex-column align-items-start mb-0">
                                                    <div>
                                                        <i class="bi bi-exclamation-triangle-fill me-2"></i>
                                                        <span>
                                                            Microphone permissions are required to select audio devices.
                                                            Please grant permission in your
                                                            browser settings to enable this feature.
                                                        </span>
                                                    </div>
                                                    <button class="btn btn-sm btn-outline-warning mt-2"
                                                        (click)="loadAudioDevices()">
                                                        <i class="bi bi-arrow-clockwise"></i> Try Again
                                                    </button>
                                                </div>
                                                } @else {
                                                <div class="mb-4">
                                                    <label for="inputDevice" class="form-label">Input Device</label>
                                                    <select id="inputDevice" class="form-select"
                                                        [ngModel]="selectedInputDevice()"
                                                        (ngModelChange)="selectedInputDevice.set($event)">
                                                        <option value="default">System Default</option>
                                                        @for(device of audioInputDevices(); track device.deviceId) {
                                                        <option [value]="device.deviceId">{{ device.label }}</option>
                                                        }
                                                    </select>
                                                </div>
                                                <div class="mb-2">
                                                    <label for="outputDevice" class="form-label">Output Device</label>
                                                    <select id="outputDevice" class="form-select"
                                                        [ngModel]="selectedOutputDevice()"
                                                        (ngModelChange)="selectedOutputDevice.set($event)">
                                                        <option value="default">System Default</option>
                                                        @for(device of audioOutputDevices(); track device.deviceId) {
                                                        <option [value]="device.deviceId">{{ device.label }}</option>
                                                        }
                                                    </select>
                                                </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            }

                            <!-- Data & Privacy Tab -->
                            @if (activeTab() === 'privacy') {
                            <div class="settings-tab-pane">
                                <h3 class="mb-4 fw-bold">Data & Privacy</h3>

                                <!-- How Rival Forge Uses Your Data -->
                                <div class="settings-section mb-5">
                                    <h5 class="section-title text-uppercase mb-3">How Rival Forge Uses Your Data</h5>
                                    <div class="settings-panel p-4 rounded-4 mb-3">
                                        <!-- Improve Rival Forge Switch -->
                                        <div class="d-flex align-items-start justify-content-between py-3">
                                            <div class="d-flex flex-column me-3">
                                                <span class="row-value fw-semibold fs-5">Use data to improve Rival
                                                    Forge</span>
                                                <span class="text-muted small mt-1">
                                                    Allows us to use and process your information to understand and
                                                    improve our services.
                                                    <span class="reveal-link text-neon-purple cursor-pointer"
                                                        (click)="showComingSoon('Learn more')">Learn more</span>
                                                </span>
                                            </div>
                                            <div class="form-check form-switch fs-4">
                                                <input class="form-check-input" type="checkbox" role="switch"
                                                    [ngModel]="improveRivalForge()"
                                                    (ngModelChange)="improveRivalForge.set($event)">
                                            </div>
                                        </div>

                                        <!-- Personalize Sponsored Content Switch -->
                                        <div class="d-flex align-items-start justify-content-between py-3">
                                            <div class="d-flex flex-column me-3">
                                                <span class="row-value fw-semibold fs-5">Use my Rival Forge activity to
                                                    personalize Sponsored Content</span>
                                                <span class="text-muted small mt-1">
                                                    Allows us to personalize Sponsored Content, like Quests, using your
                                                    Rival Forge activity, such as the games you play. If you opt out you
                                                    may still see Quests, but they won't be personalized.
                                                    <span class="reveal-link text-neon-purple cursor-pointer"
                                                        (click)="showComingSoon('Learn more')">Learn more</span>
                                                </span>
                                            </div>
                                            <div class="form-check form-switch fs-4">
                                                <input class="form-check-input" type="checkbox" role="switch"
                                                    [ngModel]="personalizeSponsoredContent()"
                                                    (ngModelChange)="personalizeSponsoredContent.set($event)">
                                            </div>
                                        </div>

                                        <!-- Third-Party Data Switch -->
                                        <div class="d-flex align-items-start justify-content-between py-3">
                                            <div class="d-flex flex-column me-3">
                                                <span class="row-value fw-semibold fs-5">Use third-party data to
                                                    personalize Sponsored Content</span>
                                                <span class="text-muted small mt-1">
                                                    Allows us to personalize Sponsored Content, like Quests, using data
                                                    we receive from advertisers and third-party data providers. If you
                                                    opt out, you may still see Quests, but they won't be personalized.
                                                    <span class="reveal-link text-neon-purple cursor-pointer"
                                                        (click)="showComingSoon('Learn more')">Learn more</span>
                                                </span>
                                            </div>
                                            <div class="form-check form-switch fs-4">
                                                <input class="form-check-input" type="checkbox" role="switch"
                                                    [ngModel]="useThirdPartyData()"
                                                    (ngModelChange)="useThirdPartyData.set($event)">
                                            </div>
                                        </div>

                                        <!-- Personalize Experience Switch -->
                                        <div class="d-flex align-items-start justify-content-between py-3">
                                            <div class="d-flex flex-column me-3">
                                                <span class="row-value fw-semibold fs-5">Use data to personalize my
                                                    Rival Forge experience</span>
                                                <span class="text-muted small mt-1">
                                                    Allows us to use information, such as who you talk to and what games
                                                    you play, to personalize Rival Forge for you.
                                                    <span class="reveal-link text-neon-purple cursor-pointer"
                                                        (click)="showComingSoon('Learn more')">Learn more</span>
                                                </span>
                                            </div>
                                            <div class="form-check form-switch fs-4">
                                                <input class="form-check-input" type="checkbox" role="switch"
                                                    [ngModel]="personalizeExperience()"
                                                    (ngModelChange)="personalizeExperience.set($event)">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Use data to make Rival Forge work static section -->
                                <div class="settings-section mb-5">
                                    <h5 class="section-title text-uppercase mb-3">Use data to make Rival Forge work</h5>
                                    <div class="settings-panel p-4 rounded-4">
                                        <span class="text-muted small">
                                            We need to store and process some data in order to provide you the basic
                                            Rival Forge service, such as your messages, what servers you're in and your
                                            Direct Messages. By using Rival Forge, you allow us to provide this basic
                                            service. You can stop this by
                                            <span class="reveal-link text-neon-purple cursor-pointer"
                                                (click)="showComingSoon('Disable Account')">Disabling</span> or
                                            <span class="reveal-link text-neon-purple cursor-pointer"
                                                (click)="showComingSoon('Delete Account')">Deleting your account</span>.
                                        </span>
                                    </div>
                                </div>

                                <!-- Voice Security -->
                                <div class="settings-section mb-5">
                                    <h5 class="section-title text-uppercase mb-3">Voice Security</h5>
                                    <div class="settings-panel p-4 rounded-4">
                                        <span class="row-value fw-semibold fs-5 d-block mb-2">Secure
                                            Communications</span>
                                        <span class="text-muted small d-block">
                                            Rival Forge utilizes state-of-the-art WebRTC encryption and media transport
                                            protocols. All voice communications are encrypted end-to-end to ensure your
                                            privacy.
                                        </span>
                                    </div>
                                </div>
                            </div>
                            }
                        </div>
                    </main>
                </div>
            </div>
            </div>
        </div>
    </div>
</div>